<template>
  <div>
    <div v-if="data">
      <div class="px-3 py-2">
        <HomeWidgetInfoItem
          v-for="(dataItem, dataItemKey) in formatViewData.main"
          :data="dataItem"
          :key="'main_' + dataItemKey"
        />
      </div>
      <div class="px-3 py-2 border" v-if="formatViewData.second.length">
        <HomeWidgetInfoItem
          v-for="(dataItem, dataItemKey) in formatViewData.second"
          :data="dataItem"
          :key="'second_' + dataItemKey"
        />
      </div>
    </div>
    <Plug v-else />
  </div>
</template>

<script>
import HomeWidgetInfoItem from './HomeWidgetInfoItem'
import Plug from 'components/Plug.vue'
export default {
  name: 'HomeWidgetToday',
  props: {
    data: {
      type: [Array, Object],
      default: null,
    },
  },
  components: {
    Plug,
    HomeWidgetInfoItem,
  },
  data: () => ({
    positions: {'not_started': '', 'started': '', 'stopped': '', 'with_reports': '', 'free_workers': ''}
  }),
  computed: {
    dataCountAll() {
      return this.data?.length > 0
        ? this.data.reduce((sum, elem) => {
            return sum + elem.project_count
          }, 0)
        : 0
    },
    formatViewData() {
      this.setPositions()
      let main = []
      let second = []
      const format = (i) => {
        let res = {
          name: i,
          count: this.positions[i],
        }
        if (i === 'with_reports' || i === 'stopped') {
          res.parent = 'started'
        }
        return res
      }
      for (let i in this.positions) {
        if (i === 'free_workers') {
          second.push(format(i))
        } else {
          main.push(format(i))
        }
      }
      return {
        main,
        second,
      }
    },
  },
  methods: {
    setPositions() {
      for (let p in this.positions) {
        this.positions[p] = this.data[p]
      }
    }
  },
}
</script>

<style scoped lang="scss">
.border {
  border-top: 1px solid #277faf;
}
</style>